<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ isNew ? 'Novo acesso da devedora' : 'Acesso da devedora' }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="!isNew" type="button" elevation="0" color="primary" outlined :loading="resending"
                            @click="resendAccess">Reenviar acesso</v-btn>
                        <v-btn type="button" elevation="0" color="primary" :loading="saving" @click="save">Salvar</v-btn>
                        <v-btn type="button" elevation="0" color="primary" outlined to="/acessos-devedora">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined">
                    <v-card-title class="card-group-title">Dados de acesso</v-card-title>
                    <v-card-text>
                        <p>
                            Ao salvar um novo acesso, a pessoa recebe por e-mail uma senha temporária e o link do Painel da Devedora,
                            onde consulta a lista de credores e as habilitações e divergências do caso e envia o contraditório.
                        </p>
                        <v-form ref="form">
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined label="Nome" v-model="form.name" counter="60"
                                        :rules="[$rules.required]" hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined label="E-mail" v-model="form.email"
                                        :rules="[$rules.required, $rules.email]" hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-autocomplete dense outlined :items="clients" label="Caso" v-model="form.client_id"
                                        item-value="id" item-text="name" :rules="[$rules.required]" hide-details="auto"
                                        no-data-text="Nenhum caso encontrado"></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    name: "ClientUserDetails",

    data: () => ({
        saving: false,
        resending: false,
        clients: [],
        form: { name: "", email: "", client_id: null },
    }),

    computed: {
        isNew() {
            return this.$route.params.id === 'novo';
        },

        breadcrumbItems() {
            return [
                { text: 'Início', to: '/home', exact: true },
                { text: 'Acessos da Devedora', to: '/acessos-devedora', exact: true },
                { text: this.isNew ? 'Incluir' : 'Detalhes', disabled: true },
            ];
        },
    },

    created() {
        this.loadClients();
        if (!this.isNew) this.load();
    },

    methods: {
        async loadClients() {
            try {
                const result = await axios.get('/api/clients', { params: { page: 1, limit: 1000 } });
                this.clients = result.data.content.data;
            } catch (error) {
                this.clients = [];
            }
        },

        async load() {
            try {
                const result = await axios.get(`/api/admin/client-users/${this.$route.params.id}`);
                const { name, email, client_id } = result.data.content;
                this.form = { name, email, client_id };
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
                this.$router.push('/acessos-devedora');
            }
        },

        async save() {
            if (!this.$refs.form.validate()) return;

            this.saving = true;

            try {
                if (this.isNew) {
                    await axios.post('/api/admin/client-users', this.form);
                    this.$dialog.notify.info('Acesso criado. A senha temporária foi enviada por e-mail.', { position: 'top-right', timeout: 4000 });
                } else {
                    await axios.patch(`/api/admin/client-users/${this.$route.params.id}`, this.form);
                    this.$dialog.notify.info('Acesso atualizado.', { position: 'top-right', timeout: 2000 });
                }

                this.$router.push('/acessos-devedora');
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 6000 });
            } finally {
                this.saving = false;
            }
        },

        async resendAccess() {
            const confirmed = await this.$dialog.confirm({
                title: 'Reenviar acesso',
                text: 'Uma nova senha temporária será gerada e enviada por e-mail. A senha atual deixa de funcionar. Deseja continuar?',
                actions: { false: 'Cancelar', true: 'Reenviar' },
            });
            if (!confirmed) return;

            this.resending = true;

            try {
                await axios.post(`/api/admin/client-users/${this.$route.params.id}/resend-access`);
                this.$dialog.notify.info('Nova senha enviada por e-mail.', { position: 'top-right', timeout: 3000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.resending = false;
            }
        },
    },
};
</script>
